define('views/email-form',[
  // These are path alias that we configured in our bootstrap
  'jquery', 'underscore', 'backbone', 'dots'],
  function($, _, Backbone){

    return Backbone.View.extend({

      events: {
        'click .hide': 'hide',
        'click .send': 'submit',
        'focus input': 'focus',
        'focus textarea': 'focus'
      },

      anchor: '',

      initialize: function(options) {
        if (options.anchor) {
          this.anchor = options.anchor;
          this.setUpAnchor();
        }
        this.$('span.dots').dots();
        this.url = options.url;
      },

      setUpAnchor: function() {
        var this_ = this;
        $(this.anchor).click(function() {
          this_.$el.slideToggle();
          if (this_.$el.is(':visible')) {
            this_.$('.message:first').focus();
          }
        });
      },

      focus: function(e) {
        var $target = $(e.target).parent();
        if ($target.hasClass('has-error')) {
          $target.removeClass('has-error');
        }
      },

      hide: function() {
        if (!$.isMobileSite()) {
          this.$el.slideUp();
        };
      },

      submit: function(e) {
        e.preventDefault();
        var $email = this.$('.email'),
            error = '';
        var fields = ['name', 'email', 'message', 'sum'];
        for (var f in fields) {
          var $f = this.$('.' + fields[f]);
          if ($.isEmptyObject($f.val())) {
            $f.parent().addClass('has-error');
            error = 'Please fill in all fields';
          }
        }
        if (error == '' && !/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test($email.val())) {
          $email.parent().addClass('has-error');
          error = 'Please enter a valid email address';
        }

        if (error.length) {
          this.$('.error').html(error).show();
        }
        else {
          this.$('.error').hide();
          this.$('.sending').show();
          var data = this.$('form').serialize();
          $.post(this.url, data, $.proxy(this.handleResponse, this));
        }
      },

      handleResponse: function(resp) {
        if (typeof resp['ok'] != 'undefined') {
          this.$('.error').removeClass('alert-danger').addClass('alert-success').addClass('has-success').html('Email sent <i class="glyphicon glyphicon-ok"></i>').show();
          this.$('.name, .email, .message, .send, .sum').attr('disabled', 'disabled').parent().addClass('has-success');
          this.$('.send').addClass('disabled').html('Sent');
        }
        else {
          this.$('.error').html(resp['error']).show();
          if (typeof resp['field'] !== 'undefined') {
            this.$('.' + resp['field']).parent().addClass('has-error');
          }
        }
        this.$('.sending').hide();
      }

    });

});
